export default "__VITE_ASSET__Dh$xpT2B__"